import { Middlewares } from "@/app/shared/services/app-router/middlewares";
import Guard from "vue-router-multiguard";

export default [
    {
        path: "/templates",
        name: "Templates",
        component: () => import("./views/templatesList.vue"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/templates/create",
        name: "CreateTemplate",
        component: () => import("./views/updateTemplate.vue"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/templates/update/:id",
        name: "UpdateTemplate",
        component: () => import("./views/updateTemplate.vue"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
];
